import { render, staticRenderFns } from "./OutsideActivity.vue?vue&type=template&id=872c4b82"
import script from "./OutsideActivity.vue?vue&type=script&lang=js"
export * from "./OutsideActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports